import { postPurchaseFlowStepArraySchema } from "@redotech/redo-flows-common/advanced-flow-db-parser";
import * as z from "zod";

export const createPostPurchaseSplitFromFlowSteps = {
  name: "createPostPurchaseSplitFromFlowSteps" as const,
  input: z.object({ flowSteps: postPurchaseFlowStepArraySchema }),
  output: z.null(),
};
